__turbopack_context__.v({
  "root": "index-module__SnvWpW__root",
});
